import { Segment } from "semantic-ui-react";
import React from "react";

export function PSCard({id, children, styleVariant = "default", noGutters = false}: {id?:string, children: React.ReactNode, styleVariant?: "default" | "defaultWithTopBorder" | "glass", noGutters?:boolean}) {
  const glassStyle: React.CSSProperties = {
    ...(noGutters ? {} : {marginBottom: '32px', padding: '40px'}),
    borderRadius: '8px',
    border: '1.2px solid rgba(255,255,255,0.22)', // semi-transparent white
    boxShadow: '0 0 0 1.5px rgba(255,255,255,0.18), 0 8px 32px 0 rgba(0,0,0,0.18)', // white glow + card shadow
    background: `linear-gradient(120deg, #0a1633 0%, #0b1e3a 60%, #000 100%)`,
    color: '#fff',
  };

  // Blue streak overlay as a child div absolutely positioned
  const streakStyle: React.CSSProperties = {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    background: `
      linear-gradient(
        120deg,
        rgba(0,0,0,0) 55%,
        rgba(0, 153, 255, 0.18) 60%,
        rgba(0, 195, 255, 0.32) 65%,
        rgba(255,255,255,0.18) 70%,
        rgba(0,0,0,0) 80%
      )
    `,
    filter: 'blur(12px) brightness(1.15)',
    opacity: 0.95,
    transition: 'background 0.3s',
  };

  const defaultStyle = {
    ...(noGutters ? {} : {marginBottom: '40px', padding: '40px'}),
    borderRadius: '16px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
    border: 'none',
  };

  const defaultStyleWithTopBorder = {
    ...defaultStyle,
    border: '1.5px solid #334155', // slate-800
    borderTop: '4px solid #64748b', // accent bar
  }
  return (
    <Segment
      // raised
      {...(id ? {id}: {})}
      style={{
        ...(styleVariant === "default" ? defaultStyle : {}),
        ...(styleVariant === "defaultWithTopBorder" ? defaultStyleWithTopBorder : {}),
        ...(styleVariant === "glass" ? glassStyle : {}),
      }}
    >
      {styleVariant === "glass" && <div style={streakStyle} />}
      {children}
    </Segment>
  );
}